import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Product.css";
import fixed_income from "../assets/fixed_income.jpg";
import insurance from "../assets/insurance.jpg";
import real_estate from "../assets/real_estate.jpg";
import pms from "../assets/pms.jpg";
import mutual_funds from "../assets/mutual_funds.jpg";
import capital_market from "../assets/capital_market.jpg";

const products = [
  {
    title: "Fixed Income",
    image: fixed_income,
    description: ["Corporate Bonds", "Certificate of Deposits", "Treasury Bonds"],
    link: "/products#fixed-income",
  },
  {
    title: "Insurance",
    image: insurance,
    description: ["Life Insurance", "Health Insurance", "Car Insurance"],
    link: "/products#insurance",
  },
  {
    title: "Real Estate",
    image: real_estate,
    description: ["Residential", "Commercial", "Industrial"],
    link: "/products#real-estate",
  },
  {
    title: "PMS",
    image: pms,
    description: ["Aggressive", "Defensive", "Hybrid"],
    link: "/products#pms",
  },
  {
    title: "Mutual Funds",
    image: mutual_funds,
    description: ["Equity Funds", "Balanced Funds", "Debt Funds"],
    link: "/products#mutual-funds",
  },
  {
    title: "Capital Market",
    image: capital_market,
    description: ["Equities", "Debt Instruments", "Preference Share"],
    link: "/products#capital-market",
  },
];

const ProductBasketSlider = () => {
  return (
    <section id="productbasket">
      <div className="container">
        <div className="title1">Product Basket</div>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={15}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          loop={false} // Disable loop for proper pagination
          breakpoints={{
            320: { slidesPerView: 1 }, // Ensure 1 slide per view
            480: { slidesPerView: 1 },
            640: { slidesPerView: 1 }, // Prevent pagination bug
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 }, // Keep original settings for desktop
          }}
        >
          {products.map((product, index) => (
            <SwiperSlide key={index}>
              <div className="item">
                <a href={product.link} className="boxl">
                  <div className="pb-box">
                    <img
                      src={product.image}
                      className="set-img img-bor"
                      alt={product.title}
                    />
                    <span className="pb-title">{product.title}</span>
                  </div>
                  <div className="pb-list">
                    <ul>
                      {product.description.map((item, idx) => (
                        <li key={idx}>
                          <a href={product.link} className="view-all">
                            {item}
                          </a>
                        </li>
                      ))}
                      <li>
                        <a href={product.link} className="view-all">
                          View All
                        </a>
                      </li>
                    </ul>
                  </div>
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ProductBasketSlider;
